if (!window.hasOwnProperty('coreModules')) {
    window.coreModules = {};
}

window.coreModules.Scroll = function() {
    var self = this;
    var $elements = $('.defer-load');
    
    function loadResources() {
        for (var i = 0; i < $elements.length; i++) {
            var position = $elements[i].getBoundingClientRect();

            if (!$($elements[i]).hasClass('loaded') && position.top !== 0 && position.top + position.height - $(window).height() < 0) {
                var func = $($elements[i]).attr('data-action');
                var params = $($elements[i]).attr('data-params');
                params = params !== undefined ? params.split(',') : []; 
                self[func](params);
                $($elements[i]).addClass('loaded');
            }
        }
    }
    
    self.vk = function (params) {
        window.vkAsyncInit = function () {
            VK.init({apiId: 2398348, onlyWidgets: true});
            var width = document.getElementById('vk_group').offsetWidth;
            VK.Widgets.Group("vk_group", {mode: 0, width: width, height: "340"}, params[0]);
        };

        var el = document.createElement("script");
        el.type = "text/javascript";
        el.src = "//vk.com/js/api/openapi.js";
        el.async = true;
        document.getElementsByTagName('head')[0].appendChild(el);
    };
    
    self.share = function() {
        var el = document.createElement("script");
        el.type = "text/javascript";
        el.src = "//yastatic.net/share2/share.js";
        el.async = true;
        document.getElementsByTagName('head')[0].appendChild(el);
    };
    
    loadResources();

    $(document).on('scroll', function(){
        loadResources();
    });
};